module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "hidden"
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "用户名",
      "placeholder": "请输入手机号/用户名",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.nameOrPhone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nameOrPhone", $$v)
      },
      expression: "formData.nameOrPhone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "type": "password",
      "label": "密码",
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loginShow = true
      }
    }
  }, [_vm._v("手机验证码登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cert-status login-success",
    style: ({
      top: _vm.success ? '0px' : '1000px'
    })
  }, [_c('div', {
    staticClass: "cert-status-content"
  }, [_c('div', {
    staticClass: "cert-status-icon-success"
  }), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v("登陆成功")])])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00b84dcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/loginDianxin.vue
// module id = 2142
// module chunks = 0